var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.749,
    height: 13.749,
    viewBox: "0 0 13.749 13.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-svgrepo-com",
    transform: "translate(-2.001 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M23.021,14.854a5.777,5.777,0,0,0-.148-1.405H16.287V16h3.866a3.35,3.35,0,0,1-1.434,2.23l-.013.085L20.788,19.9l.144.014A6.654,6.654,0,0,0,23.021,14.854Z",
    transform: "translate(-7.271 -5.827)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M9.791,24.284a6.766,6.766,0,0,0,4.645-1.665l-2.214-1.68a4.212,4.212,0,0,1-2.432.687A4.215,4.215,0,0,1,5.8,18.769l-.082.007L3.553,20.418l-.028.077A7.025,7.025,0,0,0,9.791,24.284Z",
    transform: "translate(-0.775 -8.535)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4881",
    "data-name": "Path 4881",
    d: "M5.025,14.127a4.156,4.156,0,0,1-.234-1.36,4.366,4.366,0,0,1,.226-1.36l0-.091L2.821,9.647l-.072.033a6.738,6.738,0,0,0,0,6.172Z",
    transform: "translate(0 -3.892)",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4882",
    "data-name": "Path 4882",
    d: "M9.791,4.658A3.93,3.93,0,0,1,12.5,5.682l1.98-1.894A6.815,6.815,0,0,0,9.791,2,7.025,7.025,0,0,0,3.524,5.789L5.793,7.515A4.233,4.233,0,0,1,9.791,4.658Z",
    transform: "translate(-0.775)",
    fill: "#eb4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.426ebbaea090e33c4ab8570f4fc21efa.svg";
export { ForwardRef as ReactComponent };